// extracted by mini-css-extract-plugin
export default {"stepTabContainer":"Nav_stepTabContainer__BGKzi","tabList":"Nav_tabList__3Pp8I","stepTabListItem":"Nav_stepTabListItem__WszgV","active":"Nav_active__IBB1P"};